import { Category, category_sort } from "../../Categories";
import { Id_category } from "../../api/Identifiers";
import { AssetCollection } from "../../assets/Asset";
import { CssElement } from "../../css_utils";
import { get_state, did_any_change } from "../../redux/State";
import { Keys } from "../../redux/Datastore";
import { Cookie } from "../../Cookies";
import { dispatch_action, Dispatcher } from "../../redux/Dispatcher";
import { Action, Actions } from "../../redux/Actions";
import { Configuration } from "../../Configuration";
import { AssetFilterService } from "./AssetFilterService";

let expanded_categories: Id_category[] = [];
let menu_rows_count: number = 0;
let assetFilterService = new AssetFilterService();

export class UI {
    public static readonly id_menu_assets_header: string = "menu_assets_header";
    public static readonly id_menu_assets_header_chevron: string = "menu_assets_header_chevron";
    public static readonly id_menu_assets_content: string = "menu_assets_content";
    public static readonly id_menu_assets_content_list: string = "menu_assets_content_list";


    public static get menu_assets_container(): HTMLDivElement {
        return <HTMLDivElement>document.getElementById("menu_assets_container");

    }
    public static get menu_assets_header(): HTMLElement {
        return document.getElementById(UI.id_menu_assets_header);
    }

    public static get menu_assets_content(): HTMLElement {
        return <HTMLElement>document.getElementById(UI.id_menu_assets_content);
    }

    public static get menu_assets_content_css(): CssElement {
        return new CssElement(UI.menu_assets_content);
    }

    public static set expanded(is_expanded: boolean) {
        if (is_expanded) {
            document.getElementById("menu_assets_header_chevron").classList.remove("glyphicon-chevron-right");
            document.getElementById("menu_assets_header_chevron").classList.add("glyphicon-chevron-down");
        } else {
            document.getElementById("menu_assets_header_chevron").classList.remove("glyphicon-chevron-down");
            document.getElementById("menu_assets_header_chevron").classList.add("glyphicon-chevron-right");
        }
        UI.menu_assets_content_css.visibility = is_expanded;
    }
    public static get expanded(): boolean {
        return UI.menu_assets_content_css.visibility;
    }
}

function build_and_append_child_menu_item(category: Category, floor_assets: AssetCollection, assetsFiltered: {[key: string]: boolean}): boolean {

    const assetByCategory = floor_assets.get_assets_by_category(category, assetsFiltered);
    if (assetByCategory.length === 0  || !assetByCategory.isValid) {
        return false;
    }

    let menu_idem_id: string = `id_asset__${category.id_category.value}`;
    var html = `<li style='padding: 2px; padding-left: 15px; border-radius: 0px' class='list-group-item clearfix' name='parent-category-${category.root_parent}' id="${category.id_category.value}">
  <span >
  <a href='#' id='${menu_idem_id}' class='waves-effect' id_category='${category.id_category.value}'>
  <img src='${category.icon}'  width='20' height='20' />
  <i class='material-icons'> ${category.label}</i>
  </a></span><span class='badge'>${assetByCategory.validLength}</span>
  </li>`;

    let li: HTMLLIElement = li_from_html(html);
    let is_selected: boolean = get_state().menu_asset_categories_selected.includes(category.id_category);
    if (is_selected) {
        li.classList.add("selected");
    }

    append_menu_row(li);

    let anchor: HTMLAnchorElement = <HTMLAnchorElement>document.getElementById(menu_idem_id);
    anchor.onclick = onclick_asset_menu_item;
    return true;
}

function build_and_append_parent_menu_item(category: Category, floor_assets: AssetCollection, assetsFiltered: {[key: string]: boolean}): boolean {

    if (!category.is_root_parent) {
        return false;
    }

    let is_expanded: boolean = expanded_categories.includes(category.id_category);

    let category_assets = floor_assets.get_assets_by_categories(get_state().categories.get_child_categories(category), assetsFiltered);

    if (category_assets.length === 0) {
        return false;
    }

    let menu_item_id: string = `category_parent_${category.id_category.value}`;
    let glyphicon: string = "glyphicon  glyphicon-chevron-right";
    if (is_expanded) {
        glyphicon = "glyphicon  glyphicon-chevron-down";
    }

    var html = `<li style='padding: 2px' class='list-group-item clearfix' name='${menu_item_id}'>
      <span style='display: inline-block; width:175px;'>
      <a href='#' id='${menu_item_id}' class='waves-effect' id_category='${category.id_category.value}'>
      <span class='${glyphicon}' ></span>
      <i class='material-icons'>${category.label}</i>
      </a>
      </span><span class='badge'>${category_assets.validLength}</span>
      </li>
      `;
    let li: HTMLLIElement = li_from_html(html);

    append_menu_row(li);
    let anchor: HTMLAnchorElement = <HTMLAnchorElement>document.getElementById(menu_item_id);
    anchor.onclick = onclick_asset_menu_group;

    return true;
}

function li_from_html(html: string): HTMLLIElement {
    return <HTMLLIElement>$.parseHTML(html.trim())[0];
}

function append_menu_row(li: HTMLLIElement): void {
    if (li) {
        let ul: HTMLUListElement = <HTMLUListElement>document.getElementById(UI.id_menu_assets_content_list);
        ul.appendChild(li);
        menu_rows_count++;
    }
}
function force_draw_assets_menu() {
    $("#menu_assets_content_list").html("");  // remove all assets from the menu before building the menu.

    menu_rows_count = 0;
    let top_level_categories: Category[] = get_state().categories.top_level_categories;
    top_level_categories.sort(category_sort);

    const assetsFiltered = get_state().assetsFiltered;
    const floor_assets = get_state().assets.get_assets_on_floor(get_state().id_floor, assetsFiltered, get_state().is_asset_filter_active);

    top_level_categories.forEach((parent_category: Category) => {
        if (build_and_append_parent_menu_item(parent_category, floor_assets, assetsFiltered)) {
            if (expanded_categories.includes(parent_category.id_category)) {
                let child_categories: Category[] = get_state().categories.get_child_categories(parent_category);
                child_categories.sort(category_sort);

                child_categories.forEach((child_category: Category) => {
                    build_and_append_child_menu_item(child_category, floor_assets, assetsFiltered);
                });
            }
        }
    });

    if (menu_rows_count > 0) {
        let html: string = `<li class='list-group-item' style='padding: 2px' ><a href='#' id='assets_menu_selectall'><span class='glyphicon glyphicon-check'></span>&nbsp;Select All</a></li>`;
        append_menu_row(li_from_html(html));
        document.getElementById("assets_menu_selectall").onclick = onclick_select_all;

        html = "<li class=\" list-group-item \" style=\"padding: 2px\" ><a href=\"#\" id=\"assets_menu_clear\"   ><span class= \"glyphicon glyphicon-unchecked\"></span>&nbsp; Clear All</a></li>";
        append_menu_row(li_from_html(html));
        document.getElementById("assets_menu_clear").onclick = onclick_clear_all;

    }
    if (!Configuration.read_only_mode) {
        let html: string = `<li class=" list-group-item " style="padding: 2px" >
        <a href="#" id="assets_menu_new"><span class= "glyphicon glyphicon glyphicon-plus"></span>&nbsp;Create a new asset</a>
        </li>
        `;
        append_menu_row(li_from_html(html));

        document.getElementById("assets_menu_new").onclick = onclick_create_asset;
    }

    if (menu_rows_count == 0) {
        new CssElement(UI.menu_assets_header).visibility = false;
    }
    else {
        new CssElement(UI.menu_assets_header).visibility = true;
    }

    assetFilterService.filterAssets();
}

export function draw_assets_menu() {
    if (!Configuration.assets_feature_enabled) {
        return;
    }
    if (did_any_change([Keys.KEY_STATE_FIRST_RUN])) {

        let menu_assets_container_html: string = `
        <a class="btn btn-primary" 
        style="  padding:2px;   background-color: #000;    border-color: #000  " 
        href="#" 
        id="${UI.id_menu_assets_header}">
            <span class="glyphicon  glyphicon-chevron-down" id="${UI.id_menu_assets_header_chevron}"></span> Assets
        </a>
        
        <div class="collapse in" id="${UI.id_menu_assets_content}">
            <div class="card card-block">
                <ul id="${UI.id_menu_assets_content_list}" class="list-group" style="padding: 2px"></ul>
            </div>
        </div>
        `;

        UI.menu_assets_container.innerHTML = menu_assets_container_html;
        UI.menu_assets_header.onclick = onclick_assets_menu_header;

        if (get_state().get_boolean(Keys.DID_SEGMENT_CHANGE) === false) {
            const filter = Cookie.read("assetFilter", "");
            assetFilterService.setFilter(filter);
        }
    }
    if (did_any_change([Keys.MENU_ASSETS_EXPANDED, Keys.KEY_STATE_FIRST_RUN])) {
        UI.expanded = get_state().menu_assets_expanded;
        assetFilterService.expandedCategoriesCallback = expandedCategoriesUpdate;
    }

    if (did_any_change([Keys.DATA_ASSETS, Keys.DATA_ASSETS_JSON, Keys.ID_FLOOR])) {
        assetFilterService.buildAssetStore();
    }

    // if the menu assets content changed, redraw the assets menu
    if (did_any_change([Keys.KEY_STATE_FIRST_RUN, Keys.MENU_ASSETS_SELECTED,
            Keys.DATA_ASSETS, Keys.DATA_ASSETS_JSON, Keys.ID_FLOOR, Keys.MENU_ASSETS_CONTENT])) {
        force_draw_assets_menu();

        assetFilterService.initializeAssetsFilter(menu_rows_count);
    }
}

function onclick_select_all() {
    if (assetFilterService.getFilter() !== "") {
        assetFilterService.selectAllVisibleCategories();
        return;
    }

    dispatch_action(Action.toggle_all_asset_categories(true));
}

function onclick_clear_all() {
    dispatch_action(Action.toggle_all_asset_categories(false));
}

function onclick_create_asset() {
    Dispatcher.dispatch(Actions.SET_ADD_ASSET_STATE, true);
}

function onclick_assets_menu_header(this: HTMLElement, ev: MouseEvent) {
    let expanding: boolean = !(new CssElement(UI.menu_assets_content).visibility); // !(.style.visibility === "visible");
    Cookie.write_bool(Keys.MENU_ASSETS_EXPANDED, expanding);
    dispatch_action(Action.set_menu_assets_expanded(expanding));//Action.set_key_boolean(Keys.MENU_ASSETS_EXPANDED, expanding));
}

function onclick_asset_menu_item(this: HTMLElement, ev: MouseEvent) {
    let id_category: Id_category = Id_category.wrap(this.getAttribute("id_category"));
    let is_selected: boolean = get_state().menu_asset_categories_selected.includes(id_category);
    dispatch_action(Action.toggle_asset_category(id_category, !is_selected));
}

function onclick_asset_menu_group(this: HTMLElement, ev: MouseEvent) {
    

    let id_category: Id_category = Id_category.wrap(Number.parseInt(this.getAttribute("id_category")));
    if (ev.isTrusted) {
        assetFilterService.trustedExpansionCategories.push(id_category.value);
    }
    if (expanded_categories.includes(id_category)) {
        expanded_categories = expanded_categories.filter(function (item) {
            return item !== id_category;
        });

        assetFilterService.setExpandedCategories(expanded_categories);
        assetFilterService.removeChildCategories(id_category);

        this.children[0].classList.remove("glyphicon-chevron-down");
        this.children[0].classList.add("glyphicon-chevron-right");

    } else {
        expanded_categories.push(id_category);
        assetFilterService.setExpandedCategories(expanded_categories);

        // The assets menu render cycle needs to be re-written to not have to render the entire menu again everytime a category is expanded - NV
        // We could pre-build the menu, make it so the child assets live under their parent, and then toggle the visibility of those elements.
        force_draw_assets_menu();

        assetFilterService.initializeAssetsFilter(menu_rows_count);
    }
}

function expandedCategoriesUpdate(expandedCategories: any[]) {
    expanded_categories = expandedCategories;
}